import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {MaterialDatepickerComponent} from '../material-datepicker.component';
import {FormFieldService} from '../../../../../services/form-field.service';
import {TranslateService} from '@ngx-translate/core';
import {DateAdapter, MAT_DATE_FORMATS} from '@angular/material';
import * as moment from 'moment';
import {startOfYear} from '../../../../../utils/time-utils';
import {MaterialYearPickerDateAdapter} from '../../../../../utils/material-year-picker-date-adapter';

export const YEAR_MODE_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-material-year-picker',
  templateUrl: '../material-datepicker.component.html',
  styleUrls: [],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: YEAR_MODE_FORMATS },
    {
      provide: DateAdapter,
      useClass: MaterialYearPickerDateAdapter
    }
  ]
})
export class MaterialYearPickerComponent extends MaterialDatepickerComponent implements OnInit, OnDestroy, AfterViewInit {

  constructor(public formFieldService: FormFieldService,
              public cd: ChangeDetectorRef,
              public ts: TranslateService) {
    super(formFieldService, cd, ts);
  }

  onYearSelected(event: any) {
    this.picker.close();
    const year = moment(event).year();
    setTimeout(() => {
      this.control.setValue(startOfYear(year));
      this.formFieldService.onClick(this.fieldConfig, year);
    }, 0);
  }

  protected handleDateFromManualInput(value: string): void {
    const inputYear = parseInt(value);
    if (!isNaN(inputYear)) {
      if (this.isYearAllowed(inputYear)) {
        this.control.setValue(startOfYear(inputYear));
        this.picker.close();
      } else {
        if (value && value.length === 4) {
          this.clearInput();
        }
      }
    } else {
      this.clearInput();
    }
  }

  private isYearAllowed(year: number): boolean {
    const minYear = parseInt(this.materialDatefieldConfig.minDate);
    const maxYear = parseInt(this.materialDatefieldConfig.maxDate);
    return year >= minYear && year <= maxYear;
  }

}
